/**
 * Statistics Store
 * Manages statistics data for landing page
 * Separated from monolithic store following SOLID principles
 */

import { create } from 'zustand';
import { fetchStatistics } from '../services/statistics.service';
import type { StatisticsStore } from '../interfaces/storeInterfaces/statisticsStore';

export const useStatisticsStore = create<StatisticsStore>((set) => ({
  // Initial State
  statistics: null,
  isLoading: false,
  error: null,

  // Actions
  load: async (gradeId, subjectId, countryIsoCode, languageIsoCode, jobType) => {
    set({ isLoading: true, error: null });
    try {
      const params = {
        ...(gradeId && { grade_id: gradeId }),
        ...(subjectId && { subject_id: subjectId }),
        ...(countryIsoCode && { country_iso_code: countryIsoCode }),
        ...(languageIsoCode && { language_iso_code: languageIsoCode }),
        ...(jobType && { job_type: jobType }),
      };
      const response = await fetchStatistics(params);
      set({ statistics: response.statistics, isLoading: false });
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to load statistics';
      set({ error: message, isLoading: false });
      console.error('Failed to load statistics:', error);
    }
  },

  reset: () => set({ statistics: null, isLoading: false, error: null }),
}));
